import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeCaseToProse',
  pure: true,
})
export class SnakeCaseToProsePipe implements PipeTransform {
  transform(val: string) {
    if (val != null) {
      return val.substr(0, 1).toUpperCase() + val.substr(1).replace(/_/gi, ' ');
    }
    return '';
  }
}
